export default {
  // Page titles
  deposit: 'Deposit',
  withdraw: 'Withdraw',
  transactions: 'Transactions',
  result: 'Result',
  detail: 'Detail',

  // WalletHeader
  record_button: 'Record',

  // WalletSwitch tabs
  tab_deposit: 'Deposit',
  tab_withdraw: 'Withdraw',

  // Deposit page
  deposit_currency_label: 'Deposit currency',
  choose_network_label: 'Choose coin network',
  how_to_deposit: 'How to deposit crypto？',
  deposit_address_label: 'Deposit address',
  qr_generate_failed: 'Failed to generate QR code',
  deposit_qr_alt: 'Deposit address QR code',
  deposit_address_warning: 'Send only {currency} to this deposit address. Transfers below 10 {currency} will not be credited.',
  kind_tips_heading: 'Kind tips',
  tip_1: 'The payment address changes periodically; please do not save it for long-term use. Please confirm that the information matches the system display before making payment.',
  tip_2: 'Do not deposit any network protocols or currencies other than those provided in the options to the above address, otherwise your assets will be irretrievable.',
  tip_3: 'After you recharge to the above address, confirmation from the entire network node is required. The funds will be credited to your account after two network confirmations.',
  tip_4: 'Please ensure your computer and browser are secure to prevent your information from being tampered with or leaked.',
  loading_address: 'Loading address...',
  address_copied: 'Address copied',
  copy_failed: 'Copy failed — long-press the address',

  // Withdraw page validation (inline input errors)
  invalid_address: 'Invalid {network} address',
  amount_below_min: 'Minimum withdrawal is {min} {currency}',
  amount_exceeds_balance: 'Amount exceeds available balance',
  invalid_amount: 'Enter a valid amount',

  // Withdraw page
  withdrawal_currency_label: 'Withdrawal currency',
  withdrawal_address_label: 'Withdrawal address',
  withdrawal_address_placeholder: 'Fill in carefully according to the specific currency',
  paste_blocked: 'Paste blocked — paste manually',
  withdrawal_amount_label: 'Withdrawal amount',
  withdrawal_min: 'Min: {min}{currency}',
  withdrawal_amount_placeholder: 'Withdrawal amount（0-{balance}）',
  max_button: 'Max',
  available_balance: 'Available balance',
  betting_turnover: 'Betting turnover',
  fee: 'Fee',
  actual_received: 'Maximum withdrawal amount',
  frozen_funds: 'Frozen funds',
  first_withdrawal_notice: 'For your first withdrawal, please contact @kf99h official customer service and ask them to keep your contact number. Customer service will conduct a second verification to ensure the safety of your funds.',
  preview_button: 'Withdraw',
  withdrawal_failed_message: 'Withdrawal failed',
  withdraw_blocked: 'Withdraw Blocked',
  complete_account_to_withdraw: 'For your account security, please set up an account and password to continue with your withdrawal.',
  account_banned_word: 'This account name is not allowed',
  withdrawal_initiated: 'Withdrawal successfully initiated',

  // Confirm withdrawal sheet
  confirm_withdrawal_title: 'Confirm withdrawal order',
  network_label: 'Network',
  withdrawal_address_confirm: 'Withdrawal address',
  withdrawal_amount_confirm: 'Withdrawal amount',
  withdraw_button: 'Withdraw',
  // Withdraw — password & 2FA verification
  enter_payment_password_title: 'Enter payment password',
  payment_password_placeholder: 'Please enter your payment password',
  invalid_payment_password: 'Invalid payment password',
  security_verification_title: 'Security verification',
  security_code_label: 'Google Authenticator',
  security_code_placeholder: 'Enter 6-digit code',
  paste_button: 'Paste',
  confirm_button: 'Confirm',

  // SelectSheet titles
  select_currency_title: 'Select currency',
  select_network_title: 'Select Network',
  select_address_title: 'Select address',
  address_empty: 'No saved addresses for this currency / network',
  add_now: 'Add Now',

  // Record page
  type_time_col: 'Type/Time',
  amount_balance_col: 'Amount/Balance',
  no_records: 'No records',
  record_not_found: 'Record not found',
  select_type_title: 'Select type',
  select_state_title: 'Select state',
  select_date_title: 'Select date',

  // Type filter options
  type_all: 'All type',
  type_deposit: 'Deposit',
  type_withdraw: 'Withdraw',
  type_rebate: 'Rebate',
  type_activities: 'Activities',
  type_games: 'Games',
  type_commission: 'Commission',

  // Status filter options
  status_all: 'All status',
  status_success: 'Success',
  status_pending: 'Pending',
  status_failed: 'Failed',

  // Date filter options
  date_today: 'Today',
  date_week: 'Last 7 days',
  date_month: 'Last 30 days',
  date_all: 'All time',

  // RecordDetail page
  record_detail_type: 'Type',
  record_detail_status: 'Status',
  record_detail_currency: 'Currency',
  record_detail_network: 'Network',
  record_detail_fee: 'Fee',
  record_detail_time: 'Time',
  record_detail_balance_after: 'Balance after',
  record_detail_address: 'Address',
  record_detail_tx_hash: 'Tx Hash',
  record_detail_failed_to_load: 'Failed to load record',
  record_detail_copy_address: 'Address copied',
  record_detail_copy_failed: 'Copy failed',
  copied: 'Copied',

  // RecordDetail — Figma redesign (transaction + account-change variants)
  transaction_details: 'Transaction details',
  account_change_details: 'Account change details',
  order_number: 'Order number',
  account: 'Account',
  account_change_type: 'Account change type',
  transaction_type: 'Transaction type',
  type_withdrawal: 'Withdrawal',
  type_recharge: 'Recharge',
  type_betting: 'Betting',
  type_payout: 'Payout',
  type_activity_reward: 'Activity Reward',
  vip_upgrade_rewards: 'VIP Upgrade Rewards',
  game_type: 'Game type',
  game_name: 'Game name',
  activity_name: 'Activity name',
  change_amount: 'Change amount',
  before: 'Before',
  after: 'After',
  withdrawal_currency: 'Withdrawal currency',
  deposit_currency: 'Deposit currency',
  withdrawal_network: 'Withdrawal network',
  deposit_network: 'Deposit network',
  withdrawal_address: 'Withdrawal address',
  withdrawal_amount: 'Withdrawal amount',
  deposit_amount: 'Deposit amount',
  transaction_hash: 'Transaction hash',
  status_successful: 'Successful',

  // Result page
  withdrawal_submitted: 'Withdrawal submitted',
  withdrawal_failed: 'Withdrawal failed',
  withdrawal_submitted_desc: 'Your withdrawal request is being processed. The transfer will arrive after on-chain confirmation.',
  withdrawal_failed_default: 'Something went wrong. Please try again.',
  result_currency: 'Currency',
  result_network: 'Network',
  result_address: 'Address',
  result_amount: 'Amount',
  result_fee: 'Fee',
  view_records_button: 'View Records',
  back_to_wallet: 'Back to Wallet',
  try_again: 'Try Again',

  // HowToSheet
  how_to_deposit_title: 'How to deposit crypto？',
  how_to_withdraw_title: 'How to withdraw crypto？',
  deposit_step1_title: 'Step 1: Select a Cryptocurrency',
  deposit_step1_body: 'In the deposit pop-up window, choose the crypto you want to deposit (e.g., BTC, ETH, USDT).',
  deposit_step2_title: 'Step 2: Choose the Network',
  deposit_step2_body: "For tokens like USDT, you'll need to select the correct network (e.g., ERC20, TRC20).",
  deposit_step2_note: 'Note: Make sure the network you choose matches the one used in your external wallet or exchange.',
  deposit_step3_title: 'Step 3: Copy the Deposit Address or Scan the QR Code',
  deposit_step3_body1: "You'll see a unique deposit address generated for your account.",
  deposit_step3_body2: 'Click "Copy Address" or scan the QR code with your wallet app.',
  deposit_step4_title: 'Step 4: Send crypto from your external wallet to our platform',
  deposit_step4_body: 'Choose the same network you selected when copying the "Deposit address" on our platform, and paste the copied address into your external wallet when sending or withdrawing cryptos there.',
  deposit_step5_title: 'Step 5: Wait for blockchain confirmation',
  deposit_step5_body: 'Deposits will be credited after the required number of blockchain confirmations.',
  deposit_step5_note: 'Note: Most transactions are processed within a few minutes, but this can vary.',
  deposit_step6_title: 'Step 6: Check your wallet balance on our platform',
  deposit_step6_body: 'Once the transaction succeeded, the funds will appear in your wallet automatically — ready to play!',
  withdraw_step1_title: 'Step 1: Select a Cryptocurrency',
  withdraw_step1_body: 'Open Withdraw and pick the currency you want to send out (USDT or USDC).',
  withdraw_step2_title: 'Step 2: Choose the Network',
  withdraw_step2_body: 'Pick the same network as the receiving wallet — assets sent over the wrong network are unrecoverable.',
  withdraw_step2_note: 'Note: Tron(TRC20) is fastest and cheapest for most USDT transfers.',
  withdraw_step3_title: 'Step 3: Paste the destination address',
  withdraw_step3_body1: 'Paste the address from your external wallet or exchange.',
  withdraw_step3_body2: 'Double-check the first and last 4 characters before submitting.',
  withdraw_step4_title: 'Step 4: Enter the amount and Preview',
  withdraw_step4_body: 'Enter the withdrawal amount above the minimum. The platform fee is shown in the summary.',
  withdraw_step5_title: 'Step 5: Confirm and submit',
  withdraw_step5_body: 'Review the order summary in the confirm sheet and tap Withdraw.',
  withdraw_step6_title: 'Step 6: Wait for the on-chain transfer',
  withdraw_step6_body: 'Your withdrawal will appear in your destination wallet after the network confirms.',
};
